module.exports = __webpack_public_path__ + "img/main-new.c6d2c530.jpg";